import React from 'react'
import { CmsLinkComponent } from '../..'
import { CmsLink } from '../../cmsTypes'
import { MediaImage } from './../../cmsTypes/mediaImage'

import './logo.scss'

export const Logo: React.FC<{ link: CmsLink; desktopLogo: MediaImage; mobileLogo: MediaImage }> = props => {
    let link = props?.link
    if (!link || !link?.url) {
        link = {
            name: '',
            target: '',
            url: '/',
        }
    }

    return (
        <>
            <div className="logo logo-desktop">
                <CmsLinkComponent link={link}>
                    <img src={props.desktopLogo.url} className="logo-image" alt="Fat Cats Fun" />
                </CmsLinkComponent>
            </div>
            <div className="logo logo-mobile">
                <CmsLinkComponent link={link}>
                    <img src={props.mobileLogo.url} className="logo-image" alt="Fat Cats Fun" />
                </CmsLinkComponent>
            </div>
        </>
    )
}
